import React from 'react';
import './PasswordRequirements.css';

const PasswordRequirements = ({ password, className = '' }) => {
  const requirements = [
    {
      text: 'Al menos 8 caracteres',
      test: (pwd) => pwd.length >= 8
    },
    {
      text: 'Al menos una letra mayúscula',
      test: (pwd) => /[A-Z]/.test(pwd)
    },
    {
      text: 'Al menos una letra minúscula',
      test: (pwd) => /[a-z]/.test(pwd)
    },
    {
      text: 'Al menos un número',
      test: (pwd) => /\d/.test(pwd)
    },
    {
      text: 'Al menos un carácter especial',
      test: (pwd) => /[!@#$%^&*(),.?":{}|<>]/.test(pwd)
    }
  ];

  return (
    <div className={`password-requirements ${className}`}>
      <h4>Requisitos de la contraseña:</h4>
      <ul>
        {requirements.map((requirement, index) => (
          <li 
            key={index} 
            className={requirement.test(password) ? 'valid' : ''}
          >
            {requirement.text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PasswordRequirements;
